/* globals $ */
'use strict';

$(function () {
  window.requestAnimationFrame(drawDiamond);

  let textSizeCanvas = document.createElement('canvas');
  let textSizeContext = textSizeCanvas.getContext('2d');
  function getTextWidth(text, font) {
    textSizeContext.font = font;
    let metrics = textSizeContext.measureText(text);
    return metrics.width;
  }
  const fontProps = [
    'font-style',
    'font-variant',
    'font-weight',
    'font-size',
    'font-family',
  ];
  $('.company-contact .text-field').on('input', function () {
    $(this)
      .removeClass('empty not-empty')
      .addClass($(this).val() ? 'not-empty' : 'empty');
    let cs = window.getComputedStyle(this, null);
    let font = [];
    for (let fp of fontProps) {
      font.push(cs.getPropertyValue(fp));
    }
    let w = getTextWidth($(this).val(), font.join(' '));
    $(this)
      .nextAll('.text-progress:eq(0)')
      .find('span')
      .css('width', w + 'px');
  });
  $('.company-contact .text-field').trigger('input');

  let form = $('.company-contact form');
  form.on('submit', function (e) {
    //window.adf&&window.adf.ClickTrack(this,1342781,'Skicka formulär',{}); //Tracking
    let data = form.serializeArray();
    $.post('/premium/kontakt', data)
      .done(function (data) {
        console.log('data /premium/kontakt', data);
        if (data.error) {
          form.addClass('error');
          form.removeClass('submitted');
        }
      })
      .fail(function (error) {
        console.error('error post to /premium/kontakt', error);
        form.addClass('error');
        form.removeClass('submitted');
      });
    form.addClass('submitted');
    //$(form).find('textarea, input').prop('disabled', true);
    e.preventDefault();
  });
});

$(document).ready(function () {
  updateCanvasSize();
  // Delay to fix loading bug
  setTimeout(updateCanvasSize, 100);

  $(window).scroll(function () {
    updateScroll();
  });
});

$(window).resize(updateCanvasSize);

function updateCanvasSize() {
  var canvas = document.getElementById('intro__diamond_canvas');
  let context = canvas.getContext('2d');

  let scale = window.devicePixelRatio;

  let width = 300;
  let height = 300;

  canvas.style.width = width + 'px';
  canvas.style.height = height + 'px';

  canvas.width = Math.floor(width * scale);
  canvas.height = Math.floor(height * scale);

  context.translate(canvas.width / 2, canvas.height / 2);
  context.scale(scale, scale);
  context.translate(-canvas.width / 2, -(canvas.height / 2));

  updateScroll();
}

function updateScroll() {
  var phone = $('.company-get-it-image');
  var phoneContainer = $('.company-get-it__image');

  var windowpos = $(window).scrollTop() + 600;
  var phoneStartPosition = phoneContainer.offset().top - 100;
  var top = Math.max(Math.min(windowpos - phoneStartPosition, 800), 0) / 800;

  top = scrollPhoneEasing(top) * 400 + 100;

  scrollPhoneEasing(1);
  phone.stop().animate({ top: top }, 0);
}

let diamond = {
  x: 0,
  y: 0,
  width: 130,
  height: 110,
  verticalLines: [0.0, 0.33, 0.67],
  tickSpeed: 0.007,
  rotationTicker: 0,
  rotationTickSpeed: 0.02,
  translationYTicker: 0,
  translationYTickSpeed: 0.03,
  topInset: function () {
    return this.width * 0.18;
  },
  centerInset: function () {
    return this.height * 0.27;
  },
  easing: function (t) {
    let ft = t * 2;
    if (ft < 1) {
      return 0.5 * ft * ft;
    } else {
      let ftx = ft - 1;
      return -0.5 * (ftx * (ftx - 2.0) - 1.0);
    }
  },
  draw: function (context, canvas) {
    let parent = this;
    let topInset = this.topInset();
    let centerInset = this.centerInset();

    context.strokeStyle = 'white';
    context.lineWidth = 4;
    context.lineJoin = 'round';

    context.save();
    context.beginPath();

    context.translate(canvas.width / 2, canvas.height / 2);
    context.rotate(Math.sin(this.rotationTicker) * 0.01 * Math.PI);
    context.translate(-canvas.width / 2, -(canvas.height / 2));

    let translateY = Math.sin(this.translationYTicker) * 4;
    context.translate(0, translateY);
    // Static
    {
      // Outline
      context.moveTo(topInset + this.x, this.y);
      context.lineTo(this.width - topInset + this.x, this.y);
      context.lineTo(this.width + this.x, centerInset + this.y);
      context.lineTo(this.width / 2 + this.x, this.height + this.y);
      context.lineTo(this.x, centerInset + this.y);
      context.closePath();

      // Horizontal line
      context.moveTo(this.x, centerInset + this.y);
      context.lineTo(this.x + this.width, centerInset + this.y);
    }

    // Vertical lines
    this.verticalLines.forEach(function (value) {
      value = parent.easing(value);
      context.moveTo(parent.width / 2 + parent.x, parent.y + parent.height);
      context.lineTo(parent.x + parent.width * value, centerInset + parent.y);
      context.lineTo(
        parent.x + topInset + (parent.width - topInset - topInset) * value,
        parent.y,
      );
    });

    this.verticalLines = this.verticalLines.map(function (value) {
      var v = value + parent.tickSpeed;
      while (v > 1) {
        v -= 1;
      }
      return v;
    });

    this.rotationTicker += this.rotationTickSpeed;
    this.translationYTicker += this.translationYTickSpeed;

    context.stroke();
    context.restore();
  },
};

let blings = {
  blings: [
    { value: 1, x: 0, y: 0 },
    { value: 1, x: 0, y: 0 },
  ],
  positionBound: { x: 0, y: 0, width: 100, height: 100 },
  tickSpeed: 0.05,
  draw: function (context) {
    context.strokeStyle = '#5dc2ad';
    context.lineWidth = 3;
    context.lineCap = 'round';

    let parent = this;
    context.beginPath();

    this.blings = this.blings.map(function (bling) {
      var v = bling.value + parent.tickSpeed;
      // Reset
      if (v > 1) {
        v = randomFromInterval(1.0, 5.0) * -1;
        bling.x =
          randomFromInterval(0, parent.positionBound.width) +
          parent.positionBound.x;
        bling.y =
          randomFromInterval(0, parent.positionBound.height) +
          parent.positionBound.y;
      }
      bling.value = v;
      return bling;
    });

    this.blings.forEach(function (bling) {
      let start = Math.min(Math.max((bling.value + 0.5) * 8, 0), 8);
      let end = Math.max(bling.value * 8, 0);

      if (start <= 0) {
        return;
      }

      // Right
      context.moveTo(bling.x + end, bling.y);
      context.lineTo(bling.x + start, bling.y);

      // Bottom
      context.moveTo(bling.x, bling.y + end);
      context.lineTo(bling.x, bling.y + start);

      // Left
      context.moveTo(bling.x - end, bling.y);
      context.lineTo(bling.x - start, bling.y);

      // Top
      context.moveTo(bling.x, bling.y - end);
      context.lineTo(bling.x, bling.y - start);
    });

    context.stroke();
  },
};

function drawDiamond() {
  let canvas = document.getElementById('intro__diamond_canvas');
  let context = canvas.getContext('2d');

  context.globalCompositeOperation = 'destination-over';
  context.clearRect(0, 0, canvas.width, canvas.height);

  diamond.x = Math.round((canvas.width - diamond.width) / 2);
  diamond.y = Math.round((canvas.height - diamond.height) / 2);

  blings.positionBound = {
    x: diamond.x - diamond.width * 0.1,
    y: diamond.y - diamond.height * 0.2,
    width: diamond.width + diamond.width * 0.2,
    height: diamond.height * 0.7,
  };

  blings.draw(context);
  diamond.draw(context, canvas);

  window.requestAnimationFrame(drawDiamond);
}

function randomFromInterval(min, max) {
  return Math.random() * (max - min + 1) + min;
}

function scrollPhoneEasing(t) {
  let ft = t * 2;
  if (ft < 1) {
    return 0.5 * ft * ft;
  } else {
    let ftx = ft - 1;
    return -0.5 * (ftx * (ftx - 2.0) - 1.0);
  }
}
